module.exports = __webpack_public_path__ + "images/marketing/minimal-home-bg.jpg";